import type { App, Directive } from 'vue'

function getClipEl (el: HTMLElement): HTMLElement {
  return (el.closest('.ant-menu-title-content') as HTMLElement | null) ?? el
}

function updateTitle (el: HTMLElement, text: string) {
  const clipEl = getClipEl(el)
  el.title = clipEl.scrollWidth > clipEl.clientWidth ? text : ''
}

const ellipsisTitle: Directive<HTMLElement, string> = {
  mounted (el, binding) {
    const text = binding.value ?? el.textContent ?? ''
    const onEnter = () => updateTitle(el, text)
    el.addEventListener('mouseenter', onEnter)
    ;(el as HTMLElement & { _ellipsisTitleCleanup?: () => void })._ellipsisTitleCleanup = () => {
      el.removeEventListener('mouseenter', onEnter)
    }
  },
  updated (el, binding) {
    el.title = ''
    const text = binding.value ?? el.textContent ?? ''
    updateTitle(el, text)
  },
  unmounted (el) {
    ;(el as HTMLElement & { _ellipsisTitleCleanup?: () => void })._ellipsisTitleCleanup?.()
  },
}

export function useEllipsisTitleDirective (app: App): void {
  app.directive('ellipsis-title', ellipsisTitle)
}
